export default __webpack_public_path__ + "77340f05a683d24a1669b87ef1d27421.svg";